import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  "fill-rule": "evenodd",
  stroke: "#000",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 240 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      "stroke-linejoin": "miter",
      "stroke-width": "2",
      d: "M2 237h235V2H2z"
    }, null, -1)
  ])))
}
export default { render: render }